import React, {useState} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function AddClient() {
    const [fistName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [calling_name, setCalling_name] = useState("");
    const [idNumber, setIdNumber] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");

    const navigate = useNavigate();

    const handleRegister = () => {
        axios.post("http://stream.youradio.co.za:3002/handleRegister", 
            {
                firstName: fistName,
                lastName: lastName,
                calling_name: calling_name,
                idNumber: idNumber,
                email: email,
                number: number
            }
        ).then((response) => {
            navigate("/Home")
        })
    }
  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%'}}>
        
        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{width: '30%', height: 40, padding: 10, fontSize: 24, border: '1px solid grey', borderRadius: 15}} placeholder='First Name' onChange={(e) => setFirstName(e.target.value)}/>
        </div>
            
        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{width: '30%', height: 40, padding: 10, fontSize: 24, border: '1px solid grey', borderRadius: 15}} placeholder='Last Name' type="text" onChange={(e) => setLastName(e.target.value)}/>
        </div>
        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{width: '30%', height: 40, padding: 10, fontSize: 24, border: '1px solid grey', borderRadius: 15}} placeholder='Calling Name' type="text" onChange={(e) => setCalling_name(e.target.value)}/>
        </div>
        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{width: '30%', height: 40, padding: 10, fontSize: 24, border: '1px solid grey', borderRadius: 15}} placeholder='ID Number' type="text" onChange={(e) => setIdNumber(e.target.value)}/>
        </div>
        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{width: '30%', height: 40, padding: 10, fontSize: 24, border: '1px solid grey', borderRadius: 15}} placeholder='Email' type="text" onChange={(e) => setEmail(e.target.value)}/>
        </div>
        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{width: '30%', height: 40, padding: 10, fontSize: 24, border: '1px solid grey', borderRadius: 15}} placeholder='Contact Number' type="text" onChange={(e) => setNumber(e.target.value)}/>
        </div>

        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <button style={{marginTop: 20, width: '20%', height: 40, borderRadius: 24, border: '1px solid grey', backgroundColor: 'black', color: 'white', fontSize: 18, cursor: 'pointer'}} onClick={handleRegister}>
                Add Client
            </button>
        </div>
    </div>
  )
}

export default AddClient